import React from 'react';

// Components
import {
  WpDropdown,
  WpDropdownToggle,
  WpDropdownMenu,
  WpDropdownMenuItem,
  WpDropdownMenuDivider,
  WpDropdownMenuTitle,
} from '..';
import WpIcon from '../../icon/WpIcon';
import WpButton from '../../button/WpButton';

const DropdownDocs = () => {
  return (
    <>
      <WpDropdown>
        <WpDropdownToggle>
          <WpButton>Open</WpButton>
        </WpDropdownToggle>
        <WpDropdownMenu>
          <WpDropdownMenuTitle title="Select Action" />
          <WpDropdownMenuItem>
            <WpIcon name="arrow-right" />
            Add subitem
          </WpDropdownMenuItem>
          <WpDropdownMenuItem>
            <WpIcon name="pencil" />
            Edit
          </WpDropdownMenuItem>
          <WpDropdownMenuItem>
            <WpIcon name="paperclip" />
            Attach file
          </WpDropdownMenuItem>
          <WpDropdownMenuItem disabled>
            <WpIcon name="paperclip" />
            Disabled
          </WpDropdownMenuItem>
          <WpDropdownMenuItem selected>
            <WpIcon name="paperclip" />
            Selected
          </WpDropdownMenuItem>
          <WpDropdownMenuDivider />
          <WpDropdownMenuItem color="danger">
            <WpIcon name="trash" />
            Delete item
          </WpDropdownMenuItem>
        </WpDropdownMenu>
      </WpDropdown>
    </>
  );
};

export default DropdownDocs;
